import React from 'react';
import PropTypes from 'prop-types';
import templateData, {
  localsMessages,
  isOldButtonFactory,
} from '../utility/getTemplateData';
import { getPPCCStatus } from '../utility/helper';
import { BodyText, HeadingText } from '@paypalcorp/pp-react';
import PPCC from './ppcc';

const MERCHANT_PPCC_CONFIRMED_STATUS = 'Confirmed';
const messages = localsMessages('common/subHeader');

class SubHeader extends React.Component {
  constructor() {
    super();
    const {
      label: { donateto = '', support = '', purpose: purposeLabel = '' } = {},
    } = messages || {};
    this.state = {
      donateto,
      support,
      purposeLabel,
      isVoucherFlow: templateData.isVoucherFlow,
    };
  }

  formatOrgName() {
    let { label, orgName } = this.props;
    label = label && label.toString().replace(/\s/g, '').toUpperCase();
    let OName = orgName && orgName.toString().replace(/\s/g, '').toUpperCase();
    return label.includes(OName) ? '' : orgName;
  }

  shouldShowDonationId() {
    if (this.props.page === 'member' || this.props.page === 'crossborder') {
      return true;
    }
    return isOldButtonFactory();
  }

  getFormattedOrgName(purposeLabel, orgName) {
    if (!this.state.isVoucherFlow) {
      return `${orgName}`;
    }
    return orgName;
  }

  render() {
    let { donateto = '', support = '', purposeLabel = '' } = this.state;
    let donationName = this.props.label;
    let orgName = this.formatOrgName();
    let donationId = this.props.donationId;
    let { formattedDonationName, formattedOrgName, formattedDonationId } = {};

    if (donationName === orgName) {
      formattedDonationName = donationName;
      formattedOrgName = '';
    } else {
      formattedDonationName = donationName;
    }

    if (orgName && !donationId) {
      if (donationName !== orgName) {
        formattedOrgName = this.getFormattedOrgName(purposeLabel, orgName);
      }
    }

    if (!orgName && donationId) {
      formattedDonationId = `${donationId}`;
    }

    if (orgName && donationId) {
      if (donationName !== orgName) {
        formattedDonationId = donationId;
        formattedOrgName = this.getFormattedOrgName(purposeLabel, orgName);
      } else {
        formattedOrgName = '';
        formattedDonationId = `${donationId}`;
      }
    }

    return (
      <div className="donate_sub_header donate-main-content">
        <div className="donate-to ppvx_row">
          <div className="ppvx_col-12 title ppvx_flex-column ppvx_justify-content-center">
            <BodyText
              strong={this.state.isVoucherFlow ? false : true}
              className={`${
                this.state.isVoucherFlow ? 'title-secondary' : 'title-primary'
              } no-margins text-center`}
            >
              {this.state.isVoucherFlow ? support : donateto}
            </BodyText>
          </div>
        </div>

        <div className="ppvx_row">
          <div className="ppvx_col-12">
            <div
              className="text-center"
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <HeadingText
                size="sm"
                className="name no-margins"
                id="donation-name"
                style={{ marginBottom: '4px' }}
              >
                {formattedDonationName}
                {getPPCCStatus() === MERCHANT_PPCC_CONFIRMED_STATUS ? (
                  <PPCC />
                ) : null}
              </HeadingText>
            </div>
          </div>
        </div>

        {formattedOrgName && (
          <div className="ppvx_row ppvx_align-items-center ppvx_justify-content-center">
            <BodyText className="ppvx_d-flex no-margins purpose">
              {formattedOrgName}
            </BodyText>
          </div>
        )}

        {formattedDonationId && this.shouldShowDonationId() && (
          <div className="ppvx_row ppvx_align-items-center ppvx_justify-content-center">
            <BodyText className="ppvx_d-flex no-margins">
              {formattedDonationId}
            </BodyText>
          </div>
        )}
      </div>
    );
  }
}

SubHeader.propTypes = {
  label: PropTypes.string.isRequired,
  orgName: PropTypes.string.isRequired,
  donationId: PropTypes.string,
  page: PropTypes.string,
};

export default SubHeader;
